<template>
    <div class="imgBox">
        <div class="mediaBox" v-show="Object.keys(filePath).length">
            <p v-if="mediaType == 'excel'" class="img">
                <img src="@/assets/images/exc.png" />
            </p>
            <p
                v-if="Object.keys(filePath).length"
                class="resets"
                @click="delFile"
            >
                重置
            </p>
        </div>

        <div title="点击上传" v-show="!Object.keys(filePath).length">
            <el-upload
                :auto-upload="false"
                ref="upload"
                list-type="picture-card"
                :show-file-list="false"
                class="upload-demo"
                :action="actions"
                :headers="fileInfor"
                :before-upload="beforeUploadFile"
                :on-change="changes"
                :data="data"
            >
                <i class="el-icon-plus"></i>
            </el-upload>
        </div>

        <p class="progress" v-if="percent">
            <el-progress :percentage="percent"></el-progress>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        staff_divide: {
            type: Array,
            default: () => [],
        },
        staff_visible: {
            type: Array,
            default: () => [],
        },
        // video 视频 audio音频
        mediaType: {
            type: String,
            default: 'video',
        },
    },
    computed: {
        actions() {
            let url = this.$config.request_url
            return url + 'merchant/Operation.excel/excelInCustomer'
        },
    },
    watch: {
        staff_divide: {
            immediate: true,
            handler() {
                this.data.staff_divide = this.staff_divide
            },
        },
        staff_visible: {
            immediate: true,
            handler() {
                this.data.staff_visible = this.staff_visible
            },
        },
    },
    data() {
        return {
            filePath: {},
            data: {},
            fileInfor: {},
            fileExtension: {
                excel: ['xls', 'xlsx'],
            },
            loading: true,
            domain: '',
            percent: 0,
        }
    },
    mounted() {
        this.getFileInfor()
    },
    methods: {
        init() {
            this.filePath = {}
            this.data = {}
        },
        async httpRequest() {
            this.$refs.upload.submit()
        },
        // 上传携带的参数
        async getFileInfor() {
            this.fileInfor.Authorization = this.$store.state.app.merchantAccessToken
        },
        // 上传前的钩子
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1)
            let size = file.size / 1024 / 1024
            if (extension !== 'xlsx' && extension !== 'xlx') {
                this.$message.warning('只能上传后缀是.xlsx或xlx的文件')
                return false
            }
            if (size > 5) {
                this.$message.warning('文件大小不得超过5M')
                return false
            }
        },
        // 文件发生改变时的钩子
        changes(val, vals) {
            // this.data.file = val.raw
            this.filePath = val.raw
        },
        //删除文件
        delFile() {
            this.filePath = {}
        },
    },
}
</script>

<style lang="scss" scoped>
.imgBox {
    .fileBox {
        border-radius: 5px;
        video {
            border: 1px dashed #c0ccda;
            border-radius: 5px;
            width: 300px;
            height: 200px;
        }
    }
    .img {
        width: 80px;
        height: 80px;
        padding-bottom: 20px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .resets {
        cursor: pointer;
        line-height: 15px;
        color: #95989e;
        letter-spacing: 1px;
        cursor: pointer;
    }
}
.progress {
    width: 200px;
}
</style>
